<template>
  <VpVueForm
    :fields="fields"
    :id="id"
    class="vp-p-6"
    :save="save"
    :get="get"
    :del="del"
    width="400px"
    ref="item"
    collection-cache="cardContacts"
    feature="CARDS"
  >
    <template #default="{ state, response }">
      <VpField label="Profile Image">
        <VpImageEditor
          id="PROFILE"
          v-model="profilePicture"
          crop
          #default="{ value }"
        >
          <VpMedia type="Image" size="96" :value="value" />
        </VpImageEditor>
      </VpField>

      <VpField label="Name" name="Name" rules="required">
        <VpInput>
          <VpTextBox v-model="state.name" />
        </VpInput>
      </VpField>

      <MobileNumberInput
        :calling-code-value="response?.mobileNumber.callingCode"
        :number-value="response?.mobileNumber.number"
        v-model="state.mobileNumberWithCallingCode"
        rules="email"
      />

      <VpField label="Email" name="Email" optional rules="email">
        <VpInput>
          <VpTextBox type="email" v-model="state.email" />
        </VpInput>
      </VpField>

      <VpField label="Designation" optional>
        <VpInput>
          <VpTextBox v-model="state.designation" />
        </VpInput>
      </VpField>

      <VpField label="Address" optional>
        <VpTextArea v-model="state.address" />
      </VpField>

      <VpStatusInput v-model="state.status" />
    </template>
  </VpVueForm>
</template>

<script>
import { uploadMediaToS3 } from "utils/presets";
import MobileNumberInput from "components/src/mobile-number-input.vue";
import deleteNumber from "./delete.gql";
import get from "./get.gql";
import upsert from "./upsert.gql";

export default {
  props: {
    id: [Number, String],
    cardId: [Number, String],
  },
  components: {
    MobileNumberInput,
  },
  data() {
    return {
      profilePicture: null,
      fields: [
        "name",
        "email",
        "designation",
        "profilePictureId",
        "mobileNumberWithCallingCode",
        "address",
        { name: "status", value: "active" },
      ],
    };
  },

  methods: {
    get(id) {
      return this.$query(get, {
        id,
        cardId: Number(this.cardId),
      }).then(({ data }) => {
        this.profilePicture = {
          url: data.cardContact.profilePicture?.url,
        };

        return {
          values: {
            ...data.cardContact,
            profilePictureId: data.cardContact.profilePicture?.id,
          },
          res: data,
        };
      });
    },

    async save(id, data) {
      if (this.profilePicture && this.profilePicture.status == "CHANGE") {
        const profileUploadData = {
          path: "card_contact_profile_picture",
          file: this.profilePicture,
        };
        const uploadedMedia = await uploadMediaToS3(profileUploadData);
        data.profilePictureId = uploadedMedia.id;
      } else if (
        this.profilePicture &&
        this.profilePicture.status == "DELETE"
      ) {
        data.profilePictureId = null;
      }

      return this.$mutate(upsert, {
        id: id ? Number(id) : null,
        cardId: Number(this.cardId),
        input: data,
      }).then(({ data }) => {
        this.$router.push({ name: "contacts" });
        return data;
      });
    },

    del(id) {
      return this.$mutate(deleteNumber, {
        id: id ? Number(id) : null,
        cardId: Number(this.cardId),
      }).then(({ data }) => {
        this.$router.push({ name: "contacts" });
        return data;
      });
    },
  },
};
</script>
